import React, { useEffect, useState } from "react";
import {RCCGrid, RCCIcon, RCCInput, RCCPopover, RCCRadio, RCCSwitch } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import LovMeasureUnits from "src/components/Lov/MeasureUnits";
import Title from "src/components/Title";
import DateTimePicker from "src/components/DateTimePicker";
import { useWatch } from "react-hook-form";
import { IIqtbc001, ITab, ValueIndicator } from "../interface";
import { FieldAlwaysOnRight, FieldWithPopOver } from "../styles";

const TabAdvanced: React.FC<ITab> = ({ 
	indicator,
	register,
	control,
	errors,
	hidden
}) => {
	if(hidden) return null;
	
	const { translate} = useTranslation();
	const [data,setData] = useState<IIqtbc001>(indicator);
	
	const calcularacumWatch = useWatch({
		control,
		name: "indicator.iqc001Calcularacum",
		defaultValue:data.iqc001Calcularacum
	});
	
	useEffect(() => {
		setData(indicator);
	}, [indicator]);

	return(
		<RCCGrid container item 
			justifyContent="center"
		>
			<RCCGrid container item 
				xs={12} 
				sm={10} 
				lg={8}
			>
				<RCCGrid container item 
					xs={12}
					sm={6}
				>		
					<LovMeasureUnits
						name="indicator.iqc001Taa009Id"
						label={translate("Unidade de medida")}
						control={control}
						error={errors?.indicator?.iqc001Taa009Id}
						defaultValue={data.iqc001Taa009Id?.toString()}
						isClearable
						isCreatable
					/>
				</RCCGrid>
				<RCCGrid container item 
					xs={12}
					sm={6}
					styleInline={FieldAlwaysOnRight}
					alignItems="center"
				>	
					<DateTimePicker
						name="indicator.iqc001Validade"
						type="datePicker"
						label={translate("Validade")}
						control={control}
						error={errors?.indicator?.iqc001Validade}
						defaultValue={data.iqc001Validade}
					/>
				</RCCGrid> 
				<RCCGrid container item
					wrap="nowrap"
					alignItems="center"
					xs={12} 
				>
					<RCCSwitch
						name="indicator.iqc001Ocultarformaaval"
						label={translate("Ocultar avaliação")}
						register={register}
						error={errors?.indicator?.iqc001Ocultarformaaval}
						defaultChecked={data.iqc001Ocultarformaaval}
						styleInline={FieldWithPopOver}
						labelPosition="end"
					/>
					<RCCPopover
						header={{title:translate("Ocultar avaliação")}}
						body={{text:`${translate("Ocultar indicador da forma de avaliação (Melhor pra cima/Melhor para baixo) nos gráficos")}.`}}
					>
						<RCCIcon
							name="infoCircle"
						/>
					</RCCPopover>
				</RCCGrid>
				<RCCGrid container item
					wrap="nowrap"
					alignItems="center"
					xs={12}
				>
					<RCCSwitch
						name="indicator.iqc001Verificafca"
						label={`${translate("Verifica análise crítica")} (FCA)`}
						register={register}
						error={errors?.indicator?.iqc001Verificafca}
						defaultChecked={data.iqc001Verificafca}
						styleInline={FieldWithPopOver}
						labelPosition="end"
					/>
					<RCCPopover
						header={{title:`${translate("Verifica análise crítica")} (FCA)`}}
						body={{text:translate("Verifica ausência de Análise Crítica de acordo com parâmetro 5 dos Indicadores e apresenta alerta no painel")}}
					>
						<RCCIcon
							name="infoCircle"
						/>
					</RCCPopover>
				</RCCGrid>
				<RCCGrid container item
					alignItems="center"
					xs={12}
				>
					<RCCGrid container item
						alignItems="center"
						xs={12}
						sm={6}
					>
						<RCCSwitch
							name="indicator.iqc001Calcularacum"
							label={translate("Calcular acumulados")}
							register={register}
							error={errors?.indicator?.iqc001Calcularacum}
							defaultChecked={data.iqc001Calcularacum}
							labelPosition="end"
						/>
					</RCCGrid>
					{calcularacumWatch && 
					<RCCGrid container item
						wrap="nowrap"
						alignItems="baseline"
						styleInline={FieldAlwaysOnRight}
						xs={12}
						sm={6}
					>	
						<RCCGrid container
							styleInline={FieldWithPopOver}
						>	
							<RCCInput
								name="indicator.iqc001Qtdeperant"
								label={translate("Anos anteriores")}
								register={register}
								error={errors?.indicator?.iqc001Qtdeperant}
								defaultValue={data.iqc001Qtdeperant}
								type="number"
								max="9"
								min="0"
								required
								maxLength={1}
							/>
						</RCCGrid>
						<RCCPopover
							header={{title:translate("Anos anteriores")}}
							body={{text:translate("Quantidade de anos anteriores que o sistema deve acumular nos gráficos e no painel")}}
						>
							<RCCIcon
								name="infoCircle"
							/>
						</RCCPopover>
					</RCCGrid>
					}
				</RCCGrid>
				
				<RCCGrid container item>
					<RCCGrid container item 
						xs={12}
						sm={6}
					>				
						<RCCRadio
							name="indicator.iqc001Mostrarvalor"
							register={register}
							label={`${translate("Mostrar valor")}(${translate("Painel")})`}
							error={errors?.indicator?.iqc001Mostrarvalor}
							color="purple"
							styleInline="@media (max-width: 480px){
							display: block;
						}"
							options={[
								{value:ValueIndicator.PERCENTUAL,label:translate("Percentual")},
								{value:ValueIndicator.ABSOLUTE,label:translate("Valor absoluto")}
							]}
							defaultValue={data.iqc001Mostrarvalor?.toString()||ValueIndicator.PERCENTUAL}
						/>
					</RCCGrid>
					<RCCGrid container item 
						xs={12}
						sm={6}
						styleInline={FieldAlwaysOnRight}
					>
						<RCCInput 
							type="number"
							name="indicator.iqc001DecimaisPainel"
							register={register}
							label={translate("Casas decimais painel")}
							defaultValue={data.iqc001DecimaisPainel}
							error={errors?.indicator?.iqc001DecimaisPainel}
							required
							min={0}
							max={5}
						/>
					</RCCGrid>
				</RCCGrid>
				<RCCGrid container item>
					<RCCInput 
						name="indicator.iqc001Linkexterno"
						label="Link"
						register={register}
						defaultValue={data.iqc001Linkexterno}
						maxLength={1000}
					/>
				</RCCGrid>
				<hr/>
				<RCCGrid container item>
					<RCCGrid container item>	
						<Title 
							size="md" 
							color="purple" 
							marginTop={10}
						>
							{translate("Integração")}
						</Title>
					</RCCGrid>
					<RCCGrid container item>		
						<RCCInput
							name="indicator.iqc001Codigo"
							label={translate("Código para integração")}
							register={register}
							error={errors?.indicator?.iqc001Codigo}
							defaultValue={data.iqc001Codigo}
							maxLength={20}
						/>
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</RCCGrid>
	);
};
export default TabAdvanced;
